import { PrinterState } from "../reducer/state";
import { useAppState } from "../../../appState";

export default function usePrinterState(): PrinterState {
	return useAppState().printer;
}
